import { render, staticRenderFns } from "./multipleTextShadow.vue?vue&type=template&id=413b60a1&"
import script from "./multipleTextShadow.vue?vue&type=script&lang=ts&"
export * from "./multipleTextShadow.vue?vue&type=script&lang=ts&"
import style0 from "./multipleTextShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports